<template>
    <div>
      <div class="maintenance-page" style="text-align:center;">
        <Header :home="false" />
        <div class="content">
          <p>
            Prezados,
          </p>
          <p>
            Os serviços que incidem em pagamento de emolumentos encontram-se bloqueados para manutenção do sistema e ajuste de valores. Retornaremos em breve.
          </p>
          <p>
            Qualquer dúvida, estamos à disposição!
          </p>
          <!--      <h1>Site em Manutenção</h1>-->
          <!--      <br><br>-->
          <!--      <h7>🚨 AVISO IMPORTANTE - INSTABILIDADE TEMPORÁRIA 🚨</h7>-->
          <!--      <br><br><br>-->
          <!--      <p><strong>📊 SITUAÇÃO ATUAL:</strong></p>-->
          <!--      <p>Nossa plataforma de pesquisa de protestos está enfrentando instabilidade no momento.</p>-->
          <!--      <p><strong>🔍 CAUSA IDENTIFICADA:</strong></p>-->
          <!--      <p>Problema global nos serviços da <strong>Amazon (AWS)</strong>, afetando diversos sites e aplicativos mundialmente.</p>-->
          <!--      <p><strong>⚙️ AÇÕES EM ANDAMENTO:</strong></p>-->
          <!--      <p>-->
          <!--        <ul>-->
          <!--          <li>A equipe da Amazon já está trabalhando na solução</li>-->
          <!--          <li>Monitoramento contínuo da situação</li>-->
          <!--          <li>Normalização prevista em breve</li>-->
          <!--        </ul>-->
          <!--      </p>-->
          <!--      <p><strong>📢 COMUNICAÇÃO:</strong></p>-->
          <!--      <p>Avisaremos assim que o serviço for totalmente normalizado.</p>-->
          <!--      <br><br>-->
          <!--      <p>Agradecemos sua compreensão! 🙏</p>-->
        </div>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header/index.vue";

export default {
  name: 'Maintenance',
  components: {Header},
  methods: {},
  mounted() {},
}
</script>

<style scoped>
.maintenance-page {
  display: flex;
  gap: 60px;
  flex-flow: column;
}
.maintenance-page .content {
  font-family: Arial, sans-serif;
  max-width: 600px;
  margin: auto;
  color: #333;

}
.maintenance-page ul {
  padding-left: 0px;
  margin-left: 0px;
}
.maintenance-page ul li{
  list-style: inside;
}
</style>